'use strict'

const { getWidgetData, saveWidgetData } = require('../../../functions/widgetsData')
const { ITEM_STATE_PLAYING, ITEM_STATE_PLAYED, ITEM_STATE_SCHEDULED} = require('../../../vars/itemStatus')

class RundownOverviewCtrl {

    constructor (
        $compile,
        $http,
        $scope,
        selector,
        $state,
        $rootScope,
        $timeout,
        rundownInfo,
        masterStationInfo,
        itemModelTypes,
        widgets,
        server,
        UserFilters,
        userSettings,
        yConnection,
    ) {
        this.$compile = $compile
        this.$http = $http
        this.$scope = $scope
        this.selector = selector
        this.$state = $state
        this.$rootScope = $rootScope
        this.$timeout = $timeout
        this.masterStationInfo = masterStationInfo
        this.itemModelTypes = itemModelTypes
        this.rundownInfo = rundownInfo
        this.widgets = widgets
        this.UserFilters = UserFilters
        this.userSettings = userSettings
        this.yConnection = yConnection

        this.stationId = masterStationInfo.masterStationId
        this.slaveStation = !masterStationInfo.isMasterStation
        this.readOnly = this.readOnly || this.slaveStation
        this.customFields = {}
        this.currentNavItem = 'live'
        this.widgetDragging = null
        this.badgeType = null
        this.widgetTabAmount = {}
        this.showBlocks = {}
        this.yBlocks = {}
        this.yBlocksArray = []
        this.blocks = {}

        this.server = server
        this.playingItem = false
        this.playingBlock = null
        this.nowPlayingTimer = null
        this.blockTimeout = null

        this.filterMap = []
        this.currentFilters = {}

        UserFilters.get((data) => {
            this.filterMap = data.userFilters
            this.setCurrentFilters(this.filterMap[this.stationId])
        })

        if (!$rootScope.hugeRundown) $rootScope.hugeRundown = false
        $rootScope.progress = null
        $rootScope.progressItem = null
        $rootScope.rundownInfo = rundownInfo

        userSettings.addListener((settings) => {
            for (let setting in settings) {
                if (settings.hasOwnProperty(setting)) {
                    this[setting] = settings[setting]
                }
            }
        })

        console.info('Rundown info:', this.rundownInfo)

        userSettings.promise.then(() => {
            this.containerEl = document.getElementsByClassName('sidebar')[0]
            this.navBarEl = $('._md-nav-bar-list')[0]

            this.customFieldsRaw = itemModelTypes
            itemModelTypes.forEach(modelType => {
                this.customFields[modelType.id] = modelType.fields
            })

            this.updateNowPlaying(true)
            this.initView()
        })

        $scope.$on('rundown_tab_widget_message', this.rundownTabWidgetMessage.bind(this))
        $scope.$on('rundown_register_new_rundown_tab', this.registerRundownTabWidget.bind(this))
        $scope.$on('rundown_toggle_side_container', () => this.sideContainerOpen = !this.sideContainerOpen)
        $scope.$on('rundownMenuUpdate', (event, navTab) => this.currentNavItem = navTab)
        $scope.$on('$destroy', this.destroy.bind(this))
    }

    loadTabWidgets () {
        this.widgets.getWidgetsByType('rundown_tab', this.stationId).then((widgets) => {

            angular.forEach(widgets, (widget) => {
                let el = angular.element(
                    `<md-nav-item ng-click="ctrl.setBadgeType('${widget.data_key || ''}')" md-nav-sref="rundown.widgets({widget: ${widget.id}})" name="${widget.id}">
                            ${widget.title}<div class="counter" ng-if="ctrl.widgetTabAmount[${widget.id}] != 0 && ctrl.widgetTabAmount[${widget.id}] != undefined">{{ ctrl.widgetTabAmount[${widget.id}] }}</div>
                     </md-nav-item>`
                )
                this.navBarEl.append(el[0])
                this.$compile(el)(this.$scope)
            })

            this.checkNavState()
            return widgets
        })
    }

    setBadgeType (dataKey) {
        this.$scope.$evalAsync(() => {
            this.badgeType = dataKey
        })
    }

    checkNavState () {
        if (this.$state.current.name === 'rundown.widgets') {
            this.$scope.$apply(() => {
                this.currentNavItem = this.$state.params.widget

                this.widgets.getWidgetById(this.currentNavItem, 'rundown_tab', this.stationId).then(widget => {
                    if (widget.data_key) {
                        this.setBadgeType(widget.data_key)
                    }
                })
            })
        } else if (this.$state.current.name === 'rundown.drafts') {
            this.currentNavItem = 'drafts'
        } else {
            this.currentNavItem = 'live'
        }
    }

    loadLiveWidgets () {
        const rundownInfo = this.rundownInfo
        const broadcast = rundownInfo.broadcast

        if (!broadcast) {
            return Promise.resolve([])
        }

        const program = broadcast.program

        return this.widgets.getWidgetsByType('rundown_live', this.stationId).then((widgets) => {
            this.liveWidgetsEl = angular.element('.rundown-live-widgets')[0]
            let stationId = rundownInfo.masterstation_id || window.CONFIG.station_id
            angular.forEach(widgets, (widget) => {
                let uniqueWidgetId = 'rundown_live_' + widget.id
                this.widgets.createWidgetFrame(
                    uniqueWidgetId,
                    widget,
                    {
                        broadcastId: broadcast.id,
                        programId: program.id,
                    },
                    'rundown_live',
                    (data, element) => {
                        switch (data.action) {
                            case('height-update'):
                                element.style.height = data.actionData.newHeight + 'px'
                                break
                        }
                    },
                    () => ([
                        null,
                        {
                            readOnly: this.readOnly,
                            broadcastId: rundownInfo.broadcast.id
                        }
                    ]),
                    {
                        broadcast: broadcast,
                        program: program,
                    },
                    stationId,
                    undefined,
                    rundownInfo.masterstation_system_name,
                )
                    .then(element => {
                        element.id = 'widget-' + widget.id
                        element.className = 'rundown-live-widget'
                        element.style.height = '0px'
                        this.liveWidgetsEl.append(element)
                        element.addEventListener('load', function () {
                            this.style.height = this.contentWindow.document.body.scrollHeight + 'px'
                        })
                        this.$scope.$on('$destroy', () => {
                            this.widgets.unRegisterWidget(uniqueWidgetId)
                        })
                    })
            })

            return widgets
        })
    }

    showBlock (block) {
        let blockId = block.id
        if (typeof this.showBlocks[blockId] !== 'boolean') {
            let start = this.rundownInfo.original_start,
                stop = this.rundownInfo.original_stop,
                startBlock = block.start,
                stopBlock = block.stop
            this.showBlocks[blockId] = typeof start === 'undefined' || typeof stop === 'undefined' ||
                (moment(start).isBefore(stopBlock) && moment(stop).isAfter(startBlock))
        }
        return this.showBlocks[blockId]
    }

    joinBlockRoom (block) {
        return this.yConnection.createConnection(block.id).then(yDoc => {
            this.yBlocks[block.id] = yDoc.getMap('block')
            this.yBlocksArray.push(yDoc)
            return yDoc
        })
    }

    leaveBlockRoom (blockId) {
        return new Promise(resolve => {
            this.yConnection.deleteConnection(blockId)
            resolve(true)
        })
    }

    leaveCurrentRooms () {
        let blocks = []
        for (let blockId in this.yBlocks) {
            if (this.yBlocks.hasOwnProperty(blockId)) {
                blocks.push(this.leaveBlockRoom(blockId))
            }
        }
        this.blocks = {}
        this.yBlocks = {}
        this.showBlocks = {}
        return Promise.all(blocks)
    }

    loadBlocks () {
        let promises = []
        for (let block in this.blocks) {
            if (this.blocks.hasOwnProperty(block)) {
                if (this.showBlock(this.blocks[block])) {

                    promises.push(this.joinBlockRoom(this.blocks[block]))

                } else {
                    delete this.blocks[block]
                }
            }
        }
        return Promise.all(promises)
    }

    initView () {
        this.$rootScope.$on('focusPlaying', () => this.focusPlaying())

        this.loadTabWidgets()
        this.loadLiveWidgets()
        this.blocks = _.get(this.rundownInfo, 'broadcast.blocks', [])

        this.loadBlocks().then((blocks) => {
            this.initSizeable()

            this.$timeout(() => {
                this.$scope.$apply()
            })
        })

        this.selector.addBlocks(this.yBlocks)
    }

    initSizeable () {
        let sideLeft = document.getElementsByClassName('side-left')[1]
        let handler = document.getElementsByClassName('handler')[0]

        // save the position of the rect and watch it
        let unregisterSideLeftPosWatch, sideLeftPos = 0
        const registerSideLeftPosWatch = () => {
            sideLeftPos = sideLeft.getBoundingClientRect().x
            unregisterSideLeftPosWatch = this.$scope.$watch(() => {
                return sideLeft.getBoundingClientRect().x
            }, (newSize, oldSize) => {
                if (newSize !== oldSize) {
                    sideLeftPos = newSize
                }
            })
        }

        // Prevent the select action
        this.movingSide = false

        handler.addEventListener('mousedown', event => {
            event.preventDefault()
            this.movingSide = true

            registerSideLeftPosWatch()
            document.addEventListener('mousemove', move)
            document.addEventListener('mouseup', up)
        })

        let move = event => {
            event.preventDefault()
            if (this.movingSide) {
                sideLeft.style.flexBasis = (event.clientX - sideLeftPos) + 'px'
            }
        }

        let up = event => {
            this.movingSide = false
            sideLeft.style.flexBasis = (event.clientX - sideLeftPos) + 'px'

            if (unregisterSideLeftPosWatch) {
                unregisterSideLeftPosWatch()
                unregisterSideLeftPosWatch = null
            }

            document.removeEventListener('mousemove', move)
            document.removeEventListener('mouseup', up)
        }

    }

    getItemBy (field, value) {
        const { yBlocks } = this

        for (let i in yBlocks) {
            if (yBlocks.hasOwnProperty(i)) {
                const foundItem = this.getBlockItemBy(yBlocks[i], field, value)
                if (foundItem !== null) return foundItem
            }
        }

        return null
    }

    getBlockItemBy (block, field, value) {
        if (block) {

            if (value && value.toString) {
                value = value.toString()
            } else {
                value = '' + value
            }

            const yItems = block.get('items').toArray()
            for (let index in yItems) {
                if (yItems.hasOwnProperty(index)) {

                    let yItemValue = yItems[index].get(field)
                    if (yItemValue && yItemValue.toString) {
                        yItemValue = yItemValue.toString()
                    } else {
                        yItemValue = '' + yItemValue
                    }

                    if (yItemValue === value) {
                        return yItems[index]
                    }
                }
            }
        }

        return null
    }

    getItemById (itemId) {
        return this.getItemBy('id', itemId)
    }

    registerRundownTabWidget (event, widget, uniqueWidgetId) {
        this.$scope.$on('$destroy', () => {
            this.widgets.unRegisterWidget(uniqueWidgetId)
        })
    }

    rundownTabWidgetMessage (event, widget, uniqueWidgetId, data) {
        console.log('Event fired from iframe', data)

        const readOnly = this.readOnly

        switch (data.action) {
            case('registered'):
                if (this.$state.current.name === 'rundown.widgets') {
                    if (this.$state.params.widget === widget.id) {
                        this.widgets.sendMessage(uniqueWidgetId, 'focused')
                    } else {
                        this.widgets.sendMessage(uniqueWidgetId, 'unfocused')
                    }
                } else {
                    this.widgets.sendMessage(uniqueWidgetId, 'unfocused')
                }
                break
            case('startDnd'):
                const canDragDrop = widget.data_key && !readOnly
                console.log({
                    [`Can widget "${widget.system_name}" drag and drop to RadioManager`]: canDragDrop,
                    'Widget has an data_key': !!widget.data_key,
                    'User can edit items': !readOnly,
                })
                if (canDragDrop) {
                    this.$scope.$evalAsync(() => {
                        this.widgetDragging = {
                            id: uniqueWidgetId,
                            dataKey: widget.data_key,
                        }
                    })
                }
                break
            case('stopDnd'):
                if (widget.data_key) {
                    this.$scope.$evalAsync(() => {
                        this.widgetDragging = null
                    })
                }
                break
            case('getWidgetFromItem'):
                this.rundownTabGetItem(
                    data.actionData.itemId,
                    widget.data_key,
                    (data) => {
                        this.widgets.sendMessage(uniqueWidgetId, 'getWidgetFromItemCb', data)
                    }
                )
                break
            case('saveForItem'):
                if (widget.data_key && !readOnly) {
                    this.rundownTabSave(widget.data_key, data.actionData.itemId, data.actionData.content, null)
                }
                break
            case('amountForItem'):
                if (widget.data_key) {
                    this.rundownTabSave(widget.data_key, data.actionData.itemId, null, data.actionData.amount)
                }
                break
            case('amount'):
                this.setTabAmount(widget, data.actionData)
        }
    }

    setTabAmount (widget, amount) {
        if (!this.widgetTabAmount[widget.id]) {
            this.widgetTabAmount[widget.id] = 0
        }
        let tabWidth = document.querySelector('[name="' + widget.id + '"]').offsetWidth
        let currAmount = this.widgetTabAmount[widget.id]
        this.$scope.$evalAsync(() => {
            switch (amount.type) {
                case('set'):
                    this.widgetTabAmount[widget.id] = amount.value
                    break
                case('add'):
                    this.widgetTabAmount[widget.id] = currAmount + amount.value
                    break
                case('subtract'):
                    this.widgetTabAmount[widget.id] = currAmount - amount.value
                    break
            }
            if (this.currentNavItem === widget.id && currAmount !== 0) {
                let numOfChars = currAmount.toString().length //(currAmount < 10) ? 1 : (currAmount < 100) ? 2 : 3;

                document.querySelector('.md-nav-bar md-nav-ink-bar').style.width = tabWidth - (numOfChars * 7 + 14) + 'px'
            }
        })
    }

    rundownTabGetItem (itemId, dataKey, callback) {
        let item = this.getItemById(itemId)

        if (item) {
            callback(getWidgetData(item, dataKey).content)
        } else {
            callback(false)
        }
    }

    rundownTabSave (dataKey, itemId, content, amount) {
        let item = this.getItemById(itemId)

        if (!item) {
            console.error('Item with id ' + itemId + ' not found! Can\'t save widget data')
            return
        }

        if (content) {
            saveWidgetData(item, dataKey, { content })
        } else if (amount) {
            let currAmount = getWidgetData(item, dataKey).amount

            switch (amount.type) {
                case('set'):
                    currAmount = amount.value
                    break
                case('add'):
                    currAmount = currAmount + amount.value
                    break
                case('subtract'):
                    currAmount = currAmount - amount.value
                    break
            }

            saveWidgetData(item, dataKey, {
                amount: currAmount,
            })
        }
    }

    updateFilters (filters) {
        this.filterMap[this.stationId] = filters

        this.setCurrentFilters(filters)

        let saveFilters = {}
        for (let stationId in this.filterMap) {
            if (this.filterMap.hasOwnProperty(stationId)) {
                saveFilters[stationId] = []
                for (let modelIndex in this.filterMap[stationId]) {
                    if (this.filterMap[stationId].hasOwnProperty(modelIndex)) {
                        if (this.filterMap[stationId][modelIndex].enabled == false) {
                            saveFilters[stationId].push(this.filterMap[stationId][modelIndex].id)
                        }
                    }
                }
            }
        }

        this.$rootScope.$broadcast('active_station_filters_update', filters)
        this.UserFilters.save({ 'item_filter': saveFilters })

    }

    setCurrentFilters (filters) {
        this.$rootScope.filteredRundown = false
        for (let filter in filters) {
            if (filters.hasOwnProperty(filter)) {
                this.currentFilters[filters[filter].id] = filters[filter].enabled
                if (!filters[filter].enabled) {
                    this.$rootScope.filteredRundown = true
                }
            }
        }
    }

    updateNowPlaying (firstTime = false) {
        const currentItem = this.findPlayingItem(firstTime)

        if (currentItem) {
            if (currentItem.get('id') !== this.$rootScope.progressItem) {
                this.$rootScope.progress = 0
                this.$rootScope.progressItem = currentItem.get('id')
            }

            let now = moment.utc(this.server.now())
            let start = moment(currentItem.get('start').toString())
            let duration = currentItem.get('duration').toString()
            let end = moment(start).add(duration, 'seconds')
            let timeLeft = now.diff(end)

            if (timeLeft < 0) {
                this.$rootScope.progress = 100 - (timeLeft / duration) * -0.1
            } else {
                this.$rootScope.progress = 100
            }

        } else {
            this.$rootScope.progressItem = null
            this.$rootScope.progress = 0
        }

        this.$timeout.cancel(this.nowPlayingTimer)
        this.nowPlayingTimer = this.$timeout(() => {
            this.updateNowPlaying()
        }, 200)

    }

    findPlayingBlock () {
        if (this.playingBlock) {
            return this.playingBlock
        }
        let now = moment.utc(this.server.now())
        for (let blockIndex in this.yBlocks) {
            if (this.yBlocks.hasOwnProperty(blockIndex)) {
                if (
                    now.isAfter(this.yBlocks[blockIndex].get('start')) &&
                    now.isBefore(this.yBlocks[blockIndex].get('stop'))
                ) {
                    this.playingBlock = this.yBlocks[blockIndex]

                    let blockEnd = moment.utc(this.playingBlock.get('stop'))
                    this.$timeout.cancel(this.blockTimeout)

                    this.blockTimeout = this.$timeout(() => {
                        this.playingBlock = null
                        this.findPlayingBlock()
                    }, (blockEnd - now) + 100)

                    return this.playingBlock
                }
            }
        }
    }

    findPlayingItem (firstTime = false) {
        const {
            playingItem,
            $rootScope,
            yBlocks,
        } = this

        if (playingItem && playingItem.get('status') === ITEM_STATE_PLAYING) {
            if ($rootScope.progressItem === playingItem.get('id')) return playingItem
        }

        let found = false
        const block = this.findPlayingBlock()
        if (block != null) {
            found = this.findPlayingItemInBlock(block) || false
        }

        if (firstTime && !found) {
            if (yBlocks) {
                //user just entered rundown, possibly the playing item is in the previous block!
                for (let blockIndex in yBlocks) {
                    if (yBlocks.hasOwnProperty(blockIndex)) {
                        found = this.findPlayingItemInBlock(yBlocks[blockIndex]) || false
                        if (found) break
                    }
                }
            }
        }

        this.playingItem = found
        return found
    }

    findPlayingItemInBlock (block) {
        return this.getBlockItemBy(block, 'status', ITEM_STATE_PLAYING)
    }

    findFirstScheduledItem () {
        const currentItem = this.getItemBy('status', ITEM_STATE_SCHEDULED)
        if (currentItem) return currentItem

        const firstYBlock = this.yBlocks[_.get(this.blocks[0], 'id')]
        if (firstYBlock) return firstYBlock.get('items').get(0)

        return null
    }

    focusPlaying () {
        const currentItem = this.findPlayingItem() || this.findFirstScheduledItem()
        // if (currentItem) this.$rootScope.$broadcast('focusPrep', {id: currentItem.contents.id});
        if (currentItem) window.focusPrep(currentItem.get('id'))
    }

    destroy () {
        this.$timeout.cancel(this.nowPlayingTimer)
        this.$timeout.cancel(this.hourTimeout)
        this.leaveCurrentRooms().then()
    }
}

RundownOverviewCtrl.$inject = [
    '$compile',
    '$http',
    '$scope',
    'selector',
    '$state',
    '$rootScope',
    '$timeout',
    'rundownInfo',
    'masterStationInfo',
    'itemModelTypes',
    'widgets',
    'server',
    'UserFilters',
    'userSettings',
    'yConnection',
]

module.exports = RundownOverviewCtrl
